import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { Empresa } from '../models';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class EmpresaService {
	constructor(private _apiService: ApiService) {}

	getEmpresas(_datosFiltro: object): Observable<Empresa[]> {
		return this._apiService.get(`/empresas`, _datosFiltro).pipe(map(response => this.handleResponse(response)));
	}
	private handleResponse(response) {
		const empresas: Empresa[] = [];
		if (Array.isArray([response.data.results])) {
			const dataEmpresas = response.data.results;
			return dataEmpresas.map(function(empresa, index) {
				empresa.razonSocial += ` (${empresa.id})`;
				return (empresas[index] = new Empresa(empresa));
			});
		}
		return empresas;
	}
}
